<template>
  <md-toolbar md-elevation="0" class="md-transparent">
    <div class="md-toolbar-row px-0">
      <div class="md-toolbar-section-start lg:hidden">
        <img src="/img/igs-logo.png" width="35" height="35" alt="Logo" />
        <h3 class="ml-3 text-xl font-medium">SIS</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list class="items-center">
            <li class="md-list-item mr-4">
              <router-link :to="{ name: chatPages }">
                <div>
                  <md-icon>chat</md-icon>
                  <span
                    class="mark"
                    :class="{ 'shake-chat-icon': totalUnreadMessage }"
                    v-if="totalUnreadMessage"
                    >{{ totalUnreadMessage }}
                  </span>
                </div>
              </router-link>
            </li>

            <li class="md-list-item mr-4">
              <router-link :to="{ name: notificationPage }">
                <div>
                  <md-icon>notifications</md-icon>
                  <span class="mark" v-if="totalNotify"
                    >{{ totalNotify }}
                  </span>
                </div>
              </router-link>
            </li>

            <li class="md-list-item mr-4" v-if="hasSwitchRole">
              <md-field>
                <label>{{ $t("sidebar.switch_role") }}</label>
                <md-select
                  name="role"
                  id="role"
                  v-model="currentRole"
                  @md-selected="selectRole"
                >
                  <md-option
                    v-for="(role, idx) in roles"
                    :value="role"
                    :key="'role' + idx"
                    >{{ role }}
                  </md-option>
                </md-select>
              </md-field>
            </li>

            <li
              class="md-list-item mr-4 switch-acc-child"
              v-if="hasValidRole(this.role, Role.Family)"
            >
              <md-field>
                <label>{{ $t("sidebar.switch_children") }}</label>
                <md-select
                  name="child"
                  id="child"
                  v-model="childActive"
                  @md-selected="switchAccountChild(childActive)"
                >
                  <md-option
                    v-for="(child, index) in accChildren"
                    :key="child.username + index"
                    :value="child.username"
                    >{{ child.full_name }}
                  </md-option>
                </md-select>
              </md-field>
            </li>

            <li class="md-list-item">
              <md-field>
                <label>{{ $t("sidebar.language") }}</label>
                <md-select
                  name="language"
                  id="language"
                  v-model="$i18n.locale"
                  @md-selected="changeLanguage"
                >
                  <md-option
                    v-for="(lang, index) in languages"
                    :key="lang.value + index"
                    :value="lang.value"
                    >{{ lang.label }}
                  </md-option>
                </md-select>
              </md-field>
            </li>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import {
  chat_room_names,
  dashboard_router_name,
  notification_names
} from "@/routes/routes";
import { getId } from "@/helpers/utils";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import {
  connectSocket,
  isMessageFromGeneralGroup
} from "../../../helpers/chat";

export default {
  data() {
    return {
      notificationPage: notification_names.listPage,
      chatPages: chat_room_names.listPage,
      currentRole: "",
      childActive: null,
      hasValidRole,
      Role,
      lastSender: "",
      inverValTotalUNreadMessage: null,
      languages: [
        {
          label: "English",
          value: "en"
        },
        {
          label: "Tiếng Việt",
          value: "vi"
        }
      ]
    };
  },
  props: {
    showPageName: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("fcm", ["totalNotify"]),
    ...mapGetters("chat", [
      "socketEvent",
      // "isModeSupporterLocal",
      "totalUnreadMessage"
    ]),
    ...mapGetters("user", ["role", "info", "allRole"]),
    ...mapState("switchAccountChild", ["currentChild", "accChildren"]),
    roles() {
      return this.allRole.map(role => role.name);
    },
    hasSwitchRole() {
      return !hasValidRole(this.role, [Role.Family, Role.Student]);
    }
  },
  watch: {
    socketEvent: function(newVal) {
      this.showNotifySocket(newVal);
    },
    lastSender: function(newVal) {
      if (!newVal) return;
      //10500 is the time of toast message is hidden
      setTimeout(() => {
        this.lastSender = "";
      }, 10500);
    }
    // isModeSupporterLocal(value) {
    //   this.fetchTotalUnreadMessage();
    // }
  },
  created() {
    this.FetchTotalNotify(getId(this.info));
    this.currentRole = this.role;
    this.$store.dispatch("user/SwitchRole", this.role[0]);
    if (hasValidRole(this.role, Role.Family)) {
      this.childActive = this.currentChild.username;
    }
    this.verifyOnlineStatus();
    const { uId, token } = {
      uId: this.info.chat_id,
      token: this.info.chat_token
    };
    connectSocket(uId, token);
    this.fetchTotalUnreadMessage();
  },
  methods: {
    ...mapActions("fcm", ["FetchTotalNotify"]),
    ...mapActions("user", ["SwitchRole"]),
    ...mapActions("switchAccountChild", ["setCurrentChild"]),
    ...mapActions("switchLanguage", ["switchLanguage"]),
    ...mapActions("chat", ["verifyOnlineStatus", "getTotalUnreadMessage"]),
    ...mapMutations("chat", ["setSocketEvent"]),

    fetchTotalUnreadMessage() {
      clearInterval(this.inverValTotalUNreadMessage);
      this.getTotalUnreadMessage();
      this.inverValTotalUNreadMessage = setInterval(() => {
        this.getTotalUnreadMessage();
      }, 30000);
    },
    //getUserLoginSocket() {
    // let supporterLoginRequest = {
    //   uId: process.env.VUE_APP_SUPPORTER_UID,
    //   token: process.env.VUE_APP_SUPPORTER_TOKEN
    // };
    // const userLoginRequest = {
    //   uId: this.info.chat_id,
    //   token: this.info.chat_token
    // };
    // const isSupporter = this.info.is_supporter;
    // if (isSupporter) {
    //   return this.isModeSupporterLocal
    //     ? supporterLoginRequest
    //     : userLoginRequest;
    // }
    // return userLoginRequest;
    // },
    // connectSocketIO() {
    //   let { uId, token } = this.getUserLoginSocket();
    //   connectSocket(uId, token);
    // },
    showNotifySocket(event) {
      //config for room socket , using when can't listen notify user from socket
      // if (event.fields?.args[0] === "inserted") return;
      // this.notifyMessage(firstArg);

      //config for notify socket
      const sender = event?.fields?.args[0]?.title;
      if (
        !sender ||
        this.lastSender === sender ||
        isMessageFromGeneralGroup(event?.fields?.args[1]?._id)
      )
        return;
      this.lastSender = sender;
      // Message.success(i18n.t("chat_room.new_message_from") + sender);
    },
    /*notifyMessage(args) {
     const sender = args?.fname || args?.lastMessage?.u?.username;
     const userInfo = store.getters["user/info"];
     let condition =
     args?.lastMessage?.u?.username === userInfo.username ||
     (args?.lastMessage?.u?.username === "supporter" &&
     store.getters["chat/isModeSupporterLocal"]);
     if (condition || sender === this.lastSender) return;
     Message.success(i18n.t("chat_room.new_message_from") + sender);
     this.lastSender = sender;
     },*/
    changeLanguage() {
      localStorage.setItem("language", this.$i18n.locale);
      this.switchLanguage(this.$i18n.locale);
    },
    selectRole(value) {
      this.$store.dispatch("user/SwitchRole", value);

      if (this.$route.name !== dashboard_router_name) {
        this.$router.push({ name: dashboard_router_name });
      }
    },
    switchAccountChild(childName) {
      const switchChild = this.accChildren.find(
        student => student.username === childName
      );
      if (switchChild) {
        this.setCurrentChild(switchChild);
        if (this.$route.name !== dashboard_router_name) {
          this.$router.push({ name: dashboard_router_name });
        }
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>
<style lang="scss">
.md-list-item.switch-acc-child {
  width: 300px;
}

.md-list-item .md-button .md-button-content i {
  font-size: 25px !important;
}

.mark {
  position: absolute;
  top: -10px;
  right: -10px;
  border: 1px solid #fff;
  font-size: 9px;
  background: #f44336;
  color: #fff;
  z-index: 1;
  min-width: 20px;
  padding: 0 5px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
  line-height: 19px;
}

.shake-chat-icon {
  animation: shake 1s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(1px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-2px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(2px, 0, 0);
  }
}
</style>
